if (!customElements.get('bz-scroll-top')) {
  customElements.define(
    'bz-scroll-top',
    class BzScrollTop extends HTMLElement {
      connectedCallback() {
        const after = parseInt(this.dataset.after, 10) || 400;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let ticking = false;
        this.onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            this.dataset.visible = window.scrollY > after ? 'true' : 'false';
            ticking = false;
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.querySelector('button').addEventListener('click', () => {
          window.scrollTo({ top: 0, behavior: reduced.matches ? 'auto' : 'smooth' });
          document.querySelector('#MainContent')?.focus({ preventScroll: true });
        });
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }
    }
  );
}
